import { Nav } from "react-bootstrap";
import { Navbar } from "react-bootstrap";
import { Container } from "react-bootstrap";
import logo from "../../images/logo-c.webp";

const Navigation = () => {
  return (
    <>
      <Navbar className="navBar" expand="lg">
        <Container>
          <Navbar.Brand href="/">
            <img
              width="50"
              height="auto"
              src={logo}
              alt="Designing Glory logo"
              title="Designing Glory logo"
              loading="eager"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="https://calendly.com/juliannedrager/website-app-consoltation">
                Schedule Consultation
              </Nav.Link>
              <Nav.Link href="/#testimonies">Testimonies</Nav.Link>
              {/* <Nav.Link href="/pricing">Pricing</Nav.Link> */}
              <Nav.Link href="/#contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};
export default Navigation;
